"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePosterImage = void 0;
const react_1 = require("react");
const usePosterImage = (posterUrl) => {
    const [isImageError, setIsImageError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let interval = null;
        if (isImageError) {
            interval = setInterval(() => {
                const img = new Image();
                img.onload = () => {
                    setIsImageError(false);
                    document.body.removeChild(img);
                    if (interval != null)
                        clearInterval(interval);
                };
                img.src = posterUrl !== null && posterUrl !== void 0 ? posterUrl : "";
                img.style.display = "none";
                document.body.appendChild(img);
            }, 2000);
        }
        return () => {
            if (interval)
                clearInterval(interval);
        };
    }, [isImageError, posterUrl]);
    return [isImageError, setIsImageError];
};
exports.usePosterImage = usePosterImage;
//# sourceMappingURL=usePosterImage.js.map